/**
 *
 * FeatureNotAvailable
 *
 */

import React from "react";
import classNames from "classnames";

import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

const FeatureNotAvailable = ({ children, margin }) => {
  const { t } = useTranslation();
  const child = React.Children.only(children);
  const style = {
    ...child.props.style,
    position:
      child.props.style && child.props.style.position
        ? child.props.style.position
        : "relative",
  };

  return (
    <>
      {React.cloneElement(child, { style })}
      <div className="featureNotAvailable-overlay" style={{ margin }}>
        <div className="featureNotAvailable-text">
          {t("errors.featureNotAvailableYet")}
        </div>
      </div>
    </>
  );
};

export default FeatureNotAvailable;
